(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const headerSearchToggle = document.querySelectorAll('[data-header-search-toggle]');
    const headerSearch = document.querySelector('[data-header-search]');
    const searchInput = headerSearch.querySelector('#Search');
    const hideSearch = headerSearch.dataset.hideSearch === 'true';
    let searchAutoCloseTimeout = null;

    function closeSearch() {
      headerSearch.classList.add('hidden');
      document.body.classList.remove('active-search');
    }

    headerSearchToggle.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (searchAutoCloseTimeout) {
          clearTimeout(searchAutoCloseTimeout);
          searchAutoCloseTimeout = null;
        }
        headerSearch.classList.toggle('hidden');
        if (!headerSearch.classList.contains('hidden')) {
          // Focus the search input after a brief delay to ensure the element is visible
          setTimeout(() => {
            searchInput.focus();
          }, 100);
          document.body.classList.add('active-search');
          if (hideSearch) {
            searchAutoCloseTimeout = setTimeout(() => {
              closeSearch();
              searchAutoCloseTimeout = null;
            }, 1000);
          }
        } else {
          document.body.classList.remove('active-search');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('[data-section-type="marquee"]');
    const sectionId = section ? section.getAttribute('data-section-id') : null;
    const textPath = sectionId ? section.querySelector('#text-path-' + sectionId) : null;

    if (!textPath) {
      console.warn('Text path element not found');
      return;
    }

    // Animation variables
    let startTime = null;
    const duration = 50000; // 40 seconds for one complete loop
    const pathLength = 5000;

    function animateTextPath(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      const elapsed = timestamp - startTime;
      const progress = (elapsed % duration) / duration;

      // Calculate offset so text moves in reverse direction
      // Reverse the original calculation to move from 0 to -pathLength
      let offset = -progress * pathLength;

      textPath.setAttribute('startOffset', offset);
      requestAnimationFrame(animateTextPath);
    }

    // Start the animation
    requestAnimationFrame(animateTextPath);
  });

  } catch(e) { console.error(e); }
})();
})();
